import stylesCss from "./custom-link.module.css";

import { ConfigProvider, Typography } from "antd";
import { Link } from "react-router-dom";

const CustomLink = ({
  children,
  color = "var(--color-text-base)",
  colorHover = "var(--color-secondary)",
  href,
  className = "",
  styles,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorLink: color,
          colorLinkHover: colorHover,
        },
      }}
    >
      <>
        {href ? (
          <Typography.Link
            className={className}
            href={href}
            style={styles}
            {...props}
          >
            {children}
          </Typography.Link>
        ) : (
          <Link
            className={`${className} ${stylesCss.link}`}
            style={{
              ...styles,
              "--color": color,
              "--color-hover": colorHover,
            }}
            {...props}
          >
            {children}
          </Link>
        )}
      </>
    </ConfigProvider>
  );
};

export default CustomLink;
